// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2b5ID","header":"ClearentDisclaimer_header__1Wf8z","inner":"ClearentDisclaimer_inner__32BGV"};